import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
    selector: 'a-button-default',
    templateUrl: './a-button-default.component.html',
    styleUrls: ['./a-button-default.component.scss'],
    // tslint:disable-next-line:no-host-metadata-property
})
export class AButtonDefaultComponent implements OnInit {

    // Expanded host binding
    @HostBinding('class._expanded') isExpanded: boolean = false;

    @Input()
    public labelKey: string;

    @Input()
    public loading: false;

    @Input()
    public expanded: boolean = false;

    @Input()
    public disabled: boolean = false;

    ngOnInit(): void {
        if (this.expanded) {
            this.isExpanded = true;
        }
    }
}
